import { StyleSheet, Font } from "@react-pdf/renderer";

const HEADER_BACKGROUND = "#364059";
const WHTIE_COLOR = "#FFFFFF";
const COLN_WIDTH = 100 / 5;
const MIN_WIDTH = 100 / 15;
const ROW_HEIGHT = 35;

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src:
        "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
    },
    {
      src:
        "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf",
      fontWeight: 600,
    },
    {
      src:
        "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-400.ttf",
      fontWeight: 400,
    },
  ],
});

export const styles = StyleSheet.create({
  body: {
    padding: 10,
  },
  table: {
    display: "table",
    width: "auto",
    border: "none",
    textAlign: "center",
    fontSize: "11px",
    fontFamily: "Open Sans",
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  tableRows: {
    margin: "auto",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    height: ROW_HEIGHT,
  },
  tableCol1Header: {
    width: MIN_WIDTH + "%",
    height: ROW_HEIGHT,
    fontWeight: "bold",
    backgroundColor: HEADER_BACKGROUND,
  },
  tableColHeader: {
    width: COLN_WIDTH + "%",
    height: ROW_HEIGHT,
    fontWeight: "bold",
    backgroundColor: HEADER_BACKGROUND,
  },
  tableCol1: {
    width: MIN_WIDTH + "%",
  },
  tableCol: {
    width: COLN_WIDTH + "%",
  },
  tableCellHeader: {
    margin: 5,
    fontWeight: 500,
    color: WHTIE_COLOR,
    paddingTop: "5px",
    fontWeight: 600,
  },
  tableCell: {
    margin: 5,
    fontWeight: 400,
    color: "#262626",
  },
});
